import { createClient } from "@supabase/supabase-js"
import { MODEL, SCHEMA_VERSION, SubmissionRow } from "../shared/protocol"
import { SAMPLER_VERSION } from "../shared/sampler"

// Substituted at build time; see build.mjs.
declare const __SUPABASE_URL__: string
declare const __SUPABASE_PUBLISHABLE_KEY__: string
declare const __VAD_WEB_VERSION__: string

// Nothing is read back through this client. The anon role holds INSERT and
// nothing else, so `auth` is left unconfigured and no session is persisted.
const supabase = createClient(__SUPABASE_URL__, __SUPABASE_PUBLISHABLE_KEY__, {
  auth: { persistSession: false, autoRefreshToken: false },
})

/**
 * Writes one completed comparison. This is the only thing the page sends:
 * drawing a parameter pair records nothing, so closing the tab halfway
 * through leaves no row behind.
 */
export async function submit(
  row: Omit<
    SubmissionRow,
    "id" | "schema_version" | "model" | "vad_web_version" | "sampler_version"
  >
): Promise<void> {
  const { error } = await supabase.from("submissions").insert({
    ...row,
    id: crypto.randomUUID(),
    schema_version: SCHEMA_VERSION,
    model: MODEL,
    vad_web_version: __VAD_WEB_VERSION__,
    sampler_version: SAMPLER_VERSION,
  })
  if (error) throw new Error(`could not save your answer: ${error.message}`)
}
